/**
 * 股吧相关接口
 */

import cookie from "../cookie";
import hex_md5 from "./guba_md5";

let md5_result = '' //校验字符串缓存

export default {
  /**
   * 生成股吧的校验字符串
   */
  getGubaApiH():string{
    if (md5_result != '') {
      return md5_result
    }
    var ct = cookie.get("ct")
    if(ct == null){
      ct = ''
    }
    var ut = cookie.get("ut")
    if (ut == null) {
      ut = ''
    }
    //拼接字符
    var str = "ctoken="+ct+"utoken="+ut+"_519d77b29be442f8"
    //md5加密,加密后的结果即为h参数
    md5_result = hex_md5(str)
    return md5_result
  },
  /**
   * 根据股票代码获取股吧帖子列表
   * @param code 代码
   * @param page 当前页
   * @param sorttype 排序 0：发帖时间倒序 1：回复时间倒序
   * @param pagesize 每页多少条
   */
  async getArticleListByCode(code:string, page:number,sorttype: number, pagesize:number){
    if (page == undefined) {
      page = 1
    }    
    if (pagesize == undefined) {
      pagesize = 20
    }
    if (sorttype == undefined) {
      sorttype = 0
    }

    return $.ajax({
      url: 'https://gbapi.eastmoney.com/webarticlelist/api/Article/ArticleListForMobile?callback=?',
      type: 'GET',
      dataType: 'jsonp',
      data: {
        code: code,
        sorttype: sorttype,
        ps: pagesize,
        p: page,
        deviceid: '0d2798cab1716439a343c9965c20c59d',
        version:'2',
        product: 'eastmoney',
        plat: 'wap'
      }
    }).then(back=>{
      if(back.rc == 1){
        try {
          back.re.forEach((v:any)=>{
            if(v.post_content == ''){
              v.post_content = v.post_title
            }
          })
        } catch (error) {
          
        }
        return back
      }
      else{
        return Promise.reject(back.me)
      }
    })
  },
 
}

